import { Box } from '@mui/material';

export interface PermitsInfoProps {
  permits: Array<string>;
}

export default function PermitsInfo(props: PermitsInfoProps) {
  const { permits } = props;

  return (
    <Box fontWeight={600}>
      {permits.map((permit) => (
        <div key={permit}>{permit}</div>
      ))}
    </Box>
  );
}
